<template>
  <div style="padding: 0 20px">
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!--签收限制配置-->
        <el-tab-pane :label="$t('navbar.signCofigRef')" name="first">
          <signCofig ref="signCofigRef" />
        </el-tab-pane>
        <!--登记问题件限制配置-->
        <el-tab-pane :label="$t('navbar.RegisterProblemLimitConfiguration')" name="second">
          <registrationConfiguration ref="registrationConfiguration" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import signCofig from './component/signCofig.vue';
import registrationConfiguration from './component/registrationConfiguration.vue';

export default {
  name: 'OperationLimitConfiguration',
  components: {
    signCofig,
    registrationConfiguration
  },
  data() {
    return {
      activeName: 'first'
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.name === 'first') {
        this.$refs.signCofigRef.getSearch();
      } else {
        this.$refs.registrationConfiguration.getSearch();
      }
      console.log(tab.name, 'electronicContactLimit');
    }
  }
};
</script>

<style scoped></style>
